import { GetAllSitesRequest, GetNetworkCombosRequest } from '../requers/siteRequest';

export const SITES_LOADING  = 'SITES_LOADING';
export const SITES_SUCCESS  = 'SITES_SUCCESS';
export const SITES_ERROR    = 'SITES_ERROR';
export const FILTERS_UPDATE = 'FILTERS_UPDATE';
export const COMBOS_SUCCESS = 'COMBOS_SUCCESS';

// Load network combos once on page load
export const loadNetworkCombos = () => async (dispatch) => {
	try {
		const res = await GetNetworkCombosRequest();
		dispatch({ type: COMBOS_SUCCESS, payload: res.data });
	} catch (err) {
		console.error('[loadNetworkCombos]', err?.message);
	}
};

// Load sites — called on mount + Apply button
export const loadAllSites = () => async (dispatch, getState) => {
	const { filters } = getState().sites;
	dispatch({ type: SITES_LOADING });
	try {
		const res = await GetAllSitesRequest(filters);
		dispatch({ type: SITES_SUCCESS, payload: res.data });
	} catch (err) {
		const msg = err?.response?.data?.message || err?.response?.statusText || err?.message || 'Unknown error';
		dispatch({ type: SITES_ERROR, payload: `${err?.response?.status || ''} ${msg}` });
	}
};

// Apply button — save filters + reload sites
export const applyFilters = (newFilters) => (dispatch) => {
	dispatch({ type: FILTERS_UPDATE, payload: newFilters });
	dispatch(loadAllSites());
};